module.exports = __webpack_public_path__ + "media/rendering/renderingSlide5-ba3fb4ff.png";